import React, { Component } from 'react';
import { Dropdown } from 'semantic-ui-react';

class Model extends Component {


  render() {

    return (
      <div>
        vinoth
      </div>
    );
  }
}

export default Model;
